export const SET_DECODED_DOMAINS_START = 'SET_DECODED_DOMAINS_START';
export const SET_DECODED_DOMAINS_SUCCESS = 'SET_DECODED_DOMAINS_SUCCESS';
export const SET_DECODED_DOMAINS_FAIL = 'SET_DECODED_DOMAINS_FAIL';

export const UPDATE_DECODE_DOMAINS_ALL = 'UPDATE_DECODE_DOMAINS_ALL';
export const UPDATE_DECODE_DOMAINS_ITEM = 'UPDATE_DECODE_DOMAINS_ITEM';

export const CLEAR_DECODED_DOMAINS = 'CLEAR_DECODED_DOMAINS';

export const CHECK_CONNECTION_START = 'CHECK_CONNECTION_START';
export const CHECK_CONNECTION_SUCCESS = 'CHECK_CONNECTION_SUCCESS';
export const CHECK_CONNECTION_FAIL = 'CHECK_CONNECTION_FAIL';

export const SAVE_HISTORY_DOMAINS = 'SAVE_HISTORY_DOMAINS';
export const LOAD_HISTORY_DOMAINS = 'LOAD_HISTORY_DOMAINS';
export const REMOVE_HISTORY_DOMAINS = 'REMOVE_HISTORY_DOMAINS';

export const RESET_FILTER = 'RESET_FILTER';
export const SET_FILTER_TYPE = 'SET_FILTER_TYPE';
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';

export const SHOW_AUTH_MODAL = 'SHOW_AUTH_MODAL';
export const CLOSE_AUTH_MODAL = 'CLOSE_AUTH_MODAL';

export const AUTH_START = 'AUTH_START';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_EMAIL_PASSWORD = 'AUTH_EMAIL_PASSWORD';
export const AUTH_GOOGLE_SIGN_IN = 'AUTH_GOOGLE_SIGN_IN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_FORGOT_PASSWORD = 'AUTH_FORGOT_PASSWORD';
